module.exports = __webpack_public_path__ + "static/media/ePosterLobbies.07daa35c.jpg";